import { JSX } from 'react'

import styled from 'styled-components'

import { JSONWidgetType as AdRingierJSONWidgetType } from '@widgets/AdRingier'
import { CarouselItem } from '@widgets/Carousel'
import JSONRenderer from '@components/JSONRenderer'
import AdSlide from '@components/Swiper/AdSlide'

import { isAdSlide } from './utils'

interface SlidesProps {
  itemsWithAds: (CarouselItem | AdRingierJSONWidgetType)[]
}

const SwiperSlide = styled.div`
  width: 300px;
`

const Slides = ({ itemsWithAds }: SlidesProps): JSX.Element[] =>
  itemsWithAds?.map((item, index) =>
    isAdSlide(item) ? (
      <SwiperSlide key={`carousel-slide-${index}`}>
        <AdSlide {...item} containerId={`carousel-slide-${index}`} />
      </SwiperSlide>
    ) : (
      <SwiperSlide key={item.articleId}>
        <JSONRenderer>{item}</JSONRenderer>
      </SwiperSlide>
    ),
  )

export default Slides
